import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Paper,
  TablePagination,
} from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_ENDPOINTS, BASE_URL } from "../../Utils/api";
// import "./new-category.css";
const NewBrand = () => {
  const [page, setPage] = useState(0); // Current page number
  const [rowsPerPage, setRowsPerPage] = useState(5); //
  const [brands, setBrands] = useState([]);
  const deleteBrands = async (id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}${API_ENDPOINTS.deleteBrand}/${id}`
      );
      if (response.data.statusCode === 0) {
        console.log("Delete Brand is unsuccessfull");
      }
      toast.success("Brand deleted successfully")
      setBrands(prevData =>
        prevData.filter(product => product._id !== id)
      );
    } catch (error) {
      console.error("Error deleting Brand:", error);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}${API_ENDPOINTS.getBrands}`
        );
        if (response.data.statusCode === 0) {
          console.log("Fetching Brands is unsuccessfull");
        }
        setBrands(response.data.result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const pagenatedBrands = brands.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset page number when rows per page changes
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "95%",
        }}
      >
        <div
          style={{
            fontWeight: "600",
            fontSize: "1.5rem",
            margin: "auto 20px",
            marginLeft: "75px",
          }}
        >
          Brands
        </div>
        <NavLink to="/addBrand" style={{ textDecoration: "none" }}>
          <button className="btn-pay" type="button">
            New Brand
          </button>
        </NavLink>
      </div>

      <TableContainer
        component={Paper}
        style={{
          width: "90%",
          margin: "auto",
          marginTop: "20px",
          backgroundColor: "#fff",
        }}
      >
        <Table aria-label="sales table">
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "600" }}>Brand ID</TableCell>
              <TableCell style={{ fontWeight: "600" }}>Brand Name</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {pagenatedBrands.map(c => (
              <TableRow key={c._id}>
                <TableCell>{c._id}</TableCell>

                <TableCell>{c.brandName}</TableCell>
                <TableCell style={{ fontWeight: 'bold', color: 'red', cursor: 'pointer' }} onClick={() => deleteBrands(c._id)}>Delete</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={brands.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        style={{ margin: "20px auto" }}
      />
      <ToastContainer />
    </>
  );
};

export default NewBrand;
